import { render, staticRenderFns } from "./LinkButtonModal.vue?vue&type=template&id=67816c08&scoped=true"
import script from "./LinkButtonModal.vue?vue&type=script&lang=js"
export * from "./LinkButtonModal.vue?vue&type=script&lang=js"
import style0 from "./LinkButtonModal.vue?vue&type=style&index=0&id=67816c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67816c08",
  null
  
)

export default component.exports